import { Injectable } from '@angular/core';
export interface ExamgAgencyState {
  Exam_Agency_ID: number | null;
  Course_MatserId: number | null;
}


@Injectable({
  providedIn: 'root',
})
export class StateService {
  constructor() {}
  private previousPageState: ExamgAgencyState | null = null;
  private Course_Id: number | null = null;
  setPreviousPageState(state: ExamgAgencyState | null): void {
    this.previousPageState = state;
  }

  getPreviousPageState(): ExamgAgencyState | null {
    return this.previousPageState;
  }
  setCourse_IdState(state: number | null): void {
    this.Course_Id = state;
  }

  getCourse_Id(): number | null {
    return this.Course_Id;
  }
}
